function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import InAppMessage from "./in-app-message.js";
import u from "../../managers/subscription-manager.js";

var InAppMessageButton = /*#__PURE__*/function () {
  function InAppMessageButton(s, t, i, r, h, e, n) {
    _classCallCheck(this, InAppMessageButton);

    this.text = s, this.backgroundColor = t, this.textColor = i, this.borderColor = r, this.clickAction = h, this.uri = e, this.id = n, this.text = s || "", this.backgroundColor = t || InAppMessage.th.sh, this.textColor = i || InAppMessage.th.ih, this.borderColor = r || this.backgroundColor, this.clickAction = h || InAppMessage.ClickAction.NONE, this.uri = e, null == n && (n = InAppMessageButton.Yi), this.id = n, this.So = !1, this.ti = new u();
  }

  _createClass(InAppMessageButton, [{
    key: "subscribeToClickedEvent",
    value: function subscribeToClickedEvent(s) {
      return this.ti.Dt(s);
    }
  }, {
    key: "removeSubscription",
    value: function removeSubscription(s) {
      this.ti.removeSubscription(s);
    }
  }, {
    key: "removeAllSubscriptions",
    value: function removeAllSubscriptions() {
      this.ti.removeAllSubscriptions();
    }
  }, {
    key: "$t",
    value: function $t() {
      return !this.So && (this.So = !0, this.ti.X(), !0);
    }
  }], [{
    key: "fromJson",
    value: function fromJson(s) {
      return new InAppMessageButton(s.text, s.bg_color, s.text_color, s.border_color, s.click_action, s.uri, s.id);
    }
  }]);

  return InAppMessageButton;
}();

export { InAppMessageButton as default };
InAppMessageButton.Yi = -1;